<section id="video-player" class="video-player" (clickOutside)="closeModal()">
    <div class="video-player-text">
        <h3 *ngIf="title">{{title}}</h3>
        <p *ngIf="subtitle">{{subtitle}}</p>
    </div>
    <div class="video-player-image" [ngStyle]="{'background-image': buildBackgroudImageVideo}">
        <div class="video-player-image__text">
            <h3 *ngIf="title" [ngStyle]="{fontSize: titleSize !== '' ? titleSize : null}">{{title}}</h3>
            <p *ngIf="subtitle">{{subtitle}}</p>
        </div>
        <div class="video-player-image__button" *ngIf="srcYoutube">
            <a (click)="toggleYoutubeVideo()">
                <app-svg-icon icon="youtube-play" fill="rgba(255,255,255,0.42)"></app-svg-icon>
            </a>
        </div>
    </div>
    <div class="video-player-modal" [class]="isOpenFloatVideo ? 'modal is-active' : 'modal'">
        <span class="video-player-modal__close cursor" (click)="closeModal()" *ngIf="isOpenFloatVideo">&times;</span>
        <div class='embed-container video-player-modal__content' *ngIf="isOpenFloatVideo">
            <iframe id="frame" [src]="srcYoutube | urlPipe" title="YouTube video player" allowfullscreen></iframe>
        </div>
    </div>
    <div class="video-player-cards" *ngIf="showCards">
        <div class="container video-player-cards__container">
            <div class="columns">
                <div class="column">
                    <div class="columns is-multiline is-centered is-gapless" *ngFor="let itens of cardsInformations">
                        <div [class]="'video-player-cards__container-item video-player-cards__container-item__'+ item.id"
                             *ngFor="let item of itens">
                            <div class="text-center video-player-cards__container-item__icon">
                                <app-svg-icon [icon]="item.icon"></app-svg-icon>
                            </div>
                            <div class="video-player-cards__container-item__text">
                                <p>
                                    <span [class]="cardsInformationsClass(item.title.bold)">{{item.title.label}}</span>
                                    <span *ngIf="item.subtitle" [class]="cardsInformationsClass(item.subtitle.bold)">{{item.subtitle.label}}</span>
                                    <br/>
                                    <span *ngIf="item.text" class="video-player-cards__container-item__text-subtext">{{item.text.label}}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showButtonMobile" class="video-player-button">
        <div class="buttons">
            <a class="button is-primary" (click)="goToCart()">
                <strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Assine agora&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>
            </a>
        </div>
    </div>
</section>

<ng-template #text>
</ng-template>
